module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "日期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.search.checkInRange),
      callback: function($$v) {
        _vm.$set(_vm.search, "checkInRange", $$v)
      },
      expression: "search.checkInRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getOrders
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-tabs', {
    on: {
      "tab-click": _vm.onTabChange
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "日级数据",
      "name": "date"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "月级数据",
      "name": "month"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "年级数据",
      "name": "year"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orders,
      "highlight-current-row": "",
      "fixed": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "form",
      "width": "70",
      "label": "渠道",
      "formatter": function (row) { return (_vm.fromMap[row.form]); }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "check_in_date",
      "label": "入住日期"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderCount",
      "label": "订单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "总价"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "commission",
      "label": "总佣金"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "roomStay",
      "label": "间夜数"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@11.3.4_babel-core@6.26.3_css-loader@0.26.4_vue-template-compiler@2.7.16_webpack@2.7.0/~/vue-loader/lib/template-compiler?{"id":"data-v-53cdc068"}!./~/.pnpm/vue-loader@11.3.4_babel-core@6.26.3_css-loader@0.26.4_vue-template-compiler@2.7.16_webpack@2.7.0/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/statistic.vue
// module id = 1129
// module chunks = 1